/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import Swiper from 'swiper';
import BaseControl from 'scripts/base-control';
import DomEventsManager from 'scripts/dom-events-manager';
import { Slide, Slides } from './quotes-carousel.models';
import paginationBullet from './quotes-carousel-pagination-bullet.stache';

export const QuotesCarousel = BaseControl.extend({
    init() {
        this._super();

        this.$swiperContainer = this.$element.find('.swiper-container');

        if (this.options.slides.length > 1) {
            this.initSwiper();
            DomEventsManager.subscribe(this);
        }
    },

    onScreenOrientation() {
        // set 300 ms delay to update iPhone
        // after rotation animation is finished
        _.delay(this.initSwiper.bind(this), 300);
    },

    getSwiperAutoplayOptions() {
        if (!this.options.autoRotation) {
            return;
        }

        let delay = parseInt(this.options.autoRotationInterval, 10);

        if (!_.isInteger(rotationInterval)) {
            delay = 0;
        }

        return {
            delay,
            disableOnInteraction: true,
        };
    },

    initSwiper() {
        let slides = new Slides(this.options.slides);

        if (this.swiper) {
            this.swiper.destroy(true, true);
        }

        this.swiper = new Swiper(this.$swiperContainer, {
            loop: false,
            resistanceRatio: 0.45,
            parallax: true,
            autoplay: this.getSwiperAutoplayOptions(),
            simulateTouch: true,
            speed: 1000,
            pagination: {
                el: this.$swiperContainer.find('.swiper-pagination'),
                clickable: true,
                renderBullet: (index, className) =>
                    this.$('<div>')
                        .append(
                            paginationBullet({
                                index: index,
                                className: className,
                                slideOptions: slides[index],
                            }),
                        )
                        .html(),
            },
        });
    },
});
